import React, { useEffect, useState } from "react";

// MUI
import { Grid } from "@mui/material";

// Layouts
import SmartSelector from "@/Layouts/components/InputComponents/SmartSelector";

export default function DaysPicker(props) {
	const selectableDays = [];
	const [days, setDays] = useState({ label: 0 + " Days" });

	for (let i = 0; i < (props?.daysMax || 31) / (props?.daysInterval || 1); i++)
		selectableDays.push({ label: i * (props?.daysInterval || 1) + " Days", id: i * (props?.daysInterval || 1) });

	useEffect(() => {
		setDays({ label: props?.initialValue });
	}, [props]);

	const daysPickerStyles = {
		maxWidth: 150,
		maxHeight: 30,
	};

	return (
		<Grid container>
			<Grid item xs={6}>
				<SmartSelector
					selectBy={"label"}
					options={selectableDays}
					selected={days?.label ? { label: days.label } : null}
					listBoxProps={{
						sx: { maxHeight: "223px" },
					}}
					disabled={props.readOnly}
					sx={daysPickerStyles}
					onChangeAction={(value) => props.updateData(value)}
				/>
			</Grid>
		</Grid>
	);
}
